import { Product } from "../types/product";
import { SelectedComboChoices } from "../types/combo-type";
import useComboSelections, { getSelectedCount } from "./useComboSelections";

const useComboModal = (
  product: Product,
  quantity: number,
  onAddToOrder: (
    product: Product,
    quantity: number,
    comboSelections: Record<number, SelectedComboChoices[]>,
  ) => void,
  initialSelections: Record<number, Record<number, number>> = {},
) => {
  const sections = product.sections ?? [];
  const {
    isValid,
    handleRadioSelect,
    handleStepperChange,
    getSectionSelections,
  } = useComboSelections(sections, initialSelections);

  const handleAddToOrder = () => {
    const comboSelections: Record<number, SelectedComboChoices[]> = {};
    sections.forEach((section) => {
      const sectionSel = getSectionSelections(section.id);
      comboSelections[section.id] = Object.entries(sectionSel)
        .filter(([, qty]) => qty > 0)
        .map(([productId, qty]) => ({
          productId: Number(productId),
          quantity: qty,
          isUpselling: section.isUpselling,
        }));
    });
    onAddToOrder(product, quantity, comboSelections);
  };

  return {
    sections,
    isValid,
    handleRadioSelect,
    handleStepperChange,
    handleAddToOrder,
    getSelectedCount,
    getSectionSelections,
  };
};

export default useComboModal;
